import axios from 'axios'
import api from '..'
import { isNewRelicAgentError, logger } from '../../utils/logger'

export const uploadImages = async (images: FileList | null | undefined): Promise<string[]> => {
  if (!images) return Promise.resolve([])

  logger.addPageAction('upload_images_start', {
    imagesCount: images.length,
    totalSize: Array.from(images).reduce((sum, img) => sum + img.size, 0),
    imageDetails: Array.from(images).map((img) => `${img.name}(${img.size}b,${img.type})`).join(', ')
  })

  const filesPromise = Array.from(images).map(async (image, index) => {
    try {
      const formData = new FormData()
      formData.append('images', image)

      const response = await api.post('auth/customer/upload/images', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      return response.data[0] as string
    } catch (error) {
      if (isNewRelicAgentError(error)) {
        logger.addPageAction('upload_image_nr_agent_error_ignored', {
          imageIndex: index,
          imageName: image.name
        })
        return ''
      }

      const isNetworkError = axios.isAxiosError(error) && !error.response
      logger.logError(error instanceof Error ? error : new Error('Upload image error'), {
        type: 'upload_image_error',
        isNetworkError,
        imageIndex: index,
        imageName: image.name,
        imageSize: image.size,
        imageType: image.type,
        responseStatus: axios.isAxiosError(error) ? error.response?.status : undefined,
        errorCode: axios.isAxiosError(error) ? error.code : undefined
      })
      throw error
    }
  })

  const results = await Promise.all(filesPromise)

  logger.addPageAction('upload_images_success', {
    imagesCount: results.length
  })

  return results
}
